import { useState } from 'react'
import { Group, Text, TextInput } from '@mantine/core'
import DataList from '../../components/shared/DataList'
import PageHeader from '../../components/shared/PageHeader'
import { useResource, useT } from '../../hooks'
import { keys, loadAudit } from '../../store/dataActionCreators'
import { formatDateTime } from '../../utils/format'

export default function AuditLog() {
  const t = useT()
  const [filters, setFilters] = useState({ action: '', from: '', to: '' })
  const q = Object.fromEntries(Object.entries(filters).filter(([, v]) => v))
  const { data, loading } = useResource(keys.audit(q), () => loadAudit(q))
  const set = (k) => (e) => setFilters({ ...filters, [k]: e.currentTarget.value.trim() })
  return (
    <>
      <PageHeader title="audit_title" />
      <Group mb="md" align="flex-end">
        <TextInput label={t('audit_action')} placeholder="payment.verified" onChange={set('action')} />
        <TextInput type="date" label={t('filter_from')} onChange={set('from')} />
        <TextInput type="date" label={t('filter_to')} onChange={set('to')} />
      </Group>
      <DataList items={(data?.items || []).map((r) => ({ ...r, id: String(r.id) }))} loading={loading} empty="empty_list"
        columns={[
          { key: 'at', header: 'col_date', render: (r) => formatDateTime(r.at) },
          { key: 'actor_name', header: 'col_actor', render: (r) => `${r.actor_name || '—'} (${r.actor_role || '—'})` },
          { key: 'action', header: 'audit_action', ref: true },
          { key: 'summary', header: 'col_summary', render: (r) => <Text size="sm">{r.summary}</Text> },
          { key: 'ip', header: 'col_ip', mobileHidden: true },
        ]} />
    </>
  )
}
